import React, { useState } from "react";
import {
  CheckCircle,
  AlertTriangle,
  Info,
  Copy,
  FolderOpen,
} from "lucide-react";
import "../../styles/ExportResultModal.css";

const ExportResultModal = ({ isOpen, onClose, result }) => {
  const [copied, setCopied] = useState(false);

  if (!isOpen || !result) return null;

  const { type, success, title, message, stats, details, folderName } = result;

  const getIcon = () => {
    if (success) return CheckCircle;
    if (stats?.failedCount > 0 && stats?.successCount > 0) return AlertTriangle;
    return AlertTriangle;
  };

  const getIconClass = () => {
    if (success) return "export-result-modal-success-icon";
    if (stats?.failedCount > 0 && stats?.successCount > 0)
      return "export-result-modal-warning-icon";
    return "export-result-modal-warning-icon";
  };

  const Icon = getIcon();

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="export-result-modal-overlay" onClick={handleOverlayClick}>
      <div className="export-result-modal-container">
        <div className="export-result-modal-header">
          <div className={`export-result-modal-icon-container ${getIconClass()}`}>
            <Icon style={{ width: "24px", height: "24px" }} />
          </div>
          <div>
            <h2 className="export-result-modal-title">{title}</h2>
          </div>
        </div>

        <div className="export-result-modal-body">
          <div className="export-result-modal-text">{message}</div>

          {stats && (
            <div className="export-result-modal-stats">
              <div className="export-result-modal-stats-grid">
                <div className="export-result-modal-stat-item">
                  <p className="export-result-modal-stat-number export-result-modal-total-number">
                    {stats.totalCount || stats.processedCount || 0}
                  </p>
                  <p className="export-result-modal-stat-label">Total</p>
                </div>

                {stats.successCount !== undefined && (
                  <div className="export-result-modal-stat-item">
                    <p className="export-result-modal-stat-number export-result-modal-success-number">
                      {stats.successCount}
                    </p>
                    <p className="export-result-modal-stat-label">Success</p>
                  </div>
                )}

                {stats.failedCount !== undefined && stats.failedCount > 0 && (
                  <div className="export-result-modal-stat-item">
                    <p className="export-result-modal-stat-number export-result-modal-failed-number">
                      {stats.failedCount}
                    </p>
                    <p className="export-result-modal-stat-label">Failed</p>
                  </div>
                )}
              </div>
            </div>
          )}

          {details && (
            <div className="export-result-modal-details">
              <div className="export-result-modal-details-title">
                <Info style={{ width: "16px", height: "16px" }} />
                Export Details
              </div>
              <div className="export-result-modal-details-list">
                {details.map((detail, index) => (
                  <div key={index} className="export-result-modal-detail-item">
                    • {detail}
                  </div>
                ))}
              </div>
            </div>
          )}

          {folderName && (
            <div className="export-result-modal-details">
              <div className="export-result-modal-details-title">
                <FolderOpen style={{ width: "16px", height: "16px" }} />
                Export Location
              </div>
              <div className="export-result-modal-folder-info">
                <code className="export-result-modal-folder-path">{folderName}</code>
                <button
                  onClick={() => copyToClipboard(folderName)}
                  className="export-result-modal-copy-button"
                  title="Copy folder name"
                >
                  {copied ? (
                    <CheckCircle style={{ width: "14px", height: "14px" }} />
                  ) : (
                    <Copy style={{ width: "14px", height: "14px" }} />
                  )}
                </button>
              </div>
            </div>
          )}
        </div>

        <div className="export-result-modal-footer">
          <button
            onClick={onClose}
            className="export-result-modal-button export-result-modal-button-primary"
          >
            Got it, thanks!
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExportResultModal;
